import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChildrenWithCustomProps } from 'Utils/hoc';
const SizeAwareContainer = ({ children, width = 0, ...otherProps }) => {
    // resize logic
    const [graphWidth, setGraphWidth] = useState(width);
    const container = useRef(null);
    const resizeGraph = () => {
        const containerDimensions = container.current.getBoundingClientRect();
        const newWidth = containerDimensions.width;
        const shouldResize = graphWidth !== newWidth;
        if (shouldResize) {
            setGraphWidth(newWidth);
        }
    };
    const resizeListener = useCallback(() => resizeGraph(), [graphWidth]);
    useEffect(() => resizeGraph(), []);
    useEffect(() => {
        window.addEventListener('resize', resizeListener, true);
        return () => window.removeEventListener('resize', resizeListener, true);
    }, [resizeListener]);
    const nexWidth = graphWidth || width;
    return (React.createElement("div", { className: "app-l-content-sized", ref: container, style: { width: '100%', height: '100%' } }, nexWidth ? (React.createElement(ChildrenWithCustomProps, { props: { ...otherProps, width: nexWidth } }, children)) : null));
};
export default SizeAwareContainer;
